import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// PrimeNG used within the 5 advanced sub-components
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TooltipModule } from 'primeng/tooltip';
import { DividerModule } from 'primeng/divider';

// Advanced sub-components only (not the container yet)
import { AdvancedAdConfigurationComponent } from './offer-set-configuration/offer-set-configuration.component';
import { AdvancedPageConfigurationComponent } from './page-configuration/page-configuration.component';
import { AdvancedLeadManagementComponent } from './lead-management/lead-management.component';
import { AdvancedServiceCategoriesComponent } from './service-categories/service-categories.component';
import { AdvancedGeneralSettingsComponent } from './general/advanced-general-settings.component';
import {ButtonModule} from 'primeng/button';
import {ProgressSpinnerModule} from 'primeng/progressspinner';

@NgModule({
  declarations: [
    AdvancedAdConfigurationComponent,
    AdvancedPageConfigurationComponent,
    AdvancedLeadManagementComponent,
    AdvancedServiceCategoriesComponent,
    AdvancedGeneralSettingsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    // PrimeNG used by these sub-components
    InputSwitchModule,
    InputTextModule,
    DropdownModule,
    InputTextareaModule,
    TooltipModule,
    DividerModule,
    ButtonModule,
    ProgressSpinnerModule,
  ],
  exports: [
    // Export so AdvancedSettingsComponent (in AppModule) can use them
    AdvancedAdConfigurationComponent,
    AdvancedPageConfigurationComponent,
    AdvancedLeadManagementComponent,
    AdvancedServiceCategoriesComponent,
    AdvancedGeneralSettingsComponent,
  ]
})
export class AdvancedSettingsFeatureModule {}
